import { useState } from "react";
import AppSidebar, { SB_W, SB_W_COLLAPSED } from "../../../AppSidebar";
import { usePresalesData } from "../hooks/usePresalesData";
import PresalesStatStrip from "../components/PresalesStatStrip";
import PresalesTable from "../components/PresalesTable";
import PresalesSlideover from "../components/PresalesSlideover";
import LeadFormDrawer from "../components/LeadFormDrawer";
import "../styles/PresalesViewV2Page.css";

export default function PresalesViewV2Page({ user, showToast }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(
    localStorage.getItem("sb-collapsed") === "true"
  );

  const {
    leads,
    totalLeads,
    stats,
    users,
    products,
    loading,
    filters,
    setFilters,
    refetch,
  } = usePresalesData();

  const [selectedId, setSelectedId] = useState(null);
  const [showNewLead, setShowNewLead] = useState(false);

  function handleRowClick(id) {
    setSelectedId((prev) => (prev === id ? null : id));
  }

  function closeSlideover() {
    setSelectedId(null);
  }


  return (
    <div
      className="ps-shell"
      style={{
        gridTemplateColumns: sidebarCollapsed ? `${SB_W_COLLAPSED} 1fr` : `${SB_W} 1fr`,
      }}
    >
      <AppSidebar
        user={user}
        collapsed={sidebarCollapsed}
        onCollapse={() => {
          setSidebarCollapsed((c) => {
            const next = !c;
            localStorage.setItem("sb-collapsed", String(next));
            return next;
          });
        }}
      />

      <div className="ps-main">
        {/* Header */}
        <div className="page-head">
          <h1>Pre-Sales <em>{leads.length} of {totalLeads}</em></h1>
          <div className="page-head-actions">
            <button className="ps-new-btn v2-btn-primary" onClick={() => setShowNewLead(true)}>
              <span className="plus">+</span>
              New Lead
            </button>
          </div>
        </div>

        {/* Stat strip */}
        <PresalesStatStrip stats={stats} />

        {/* Toolbar */}
        <div className="page-toolbar">
          <div className="ps-toolbar-inner">
            {/* Search */}
            <div className="ps-toolbar-search">
              <svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
              <input
                type="text"
                className="ps-search-input"
                placeholder="Search leads…"
                value={filters.q}
                onChange={(e) => setFilters((p) => ({ ...p, q: e.target.value }))}
              />
            </div>

            <div className="ps-toolbar-spacer" />

            {/* Open / All scope toggle — right-aligned */}
            <div className="ps-seg">
              <button
                className={filters.scope === "open" ? "on" : ""}
                onClick={() => setFilters((p) => ({ ...p, scope: "open" }))}
              >
                Open
              </button>
              <button
                className={filters.scope === "all" ? "on" : ""}
                onClick={() => setFilters((p) => ({ ...p, scope: "all" }))}
              >
                All
              </button>
            </div>
          </div>
        </div>

        {/* Table */}
        {loading ? (
          <div className="ps-loading">Loading leads…</div>
        ) : (
          <PresalesTable
            leads={leads}
            selectedId={selectedId}
            onSelect={handleRowClick}
          />
        )}
      </div>

      {/* Slide-over */}
      {selectedId && (
        <PresalesSlideover
          leadId={selectedId}
          onClose={closeSlideover}
          onLeadChange={refetch}
          showToast={showToast}
        />
      )}

      {/* New lead drawer */}
      {showNewLead && (
        <LeadFormDrawer
          users={users}
          products={products}
          onClose={() => setShowNewLead(false)}
          onSave={async () => { setShowNewLead(false); await refetch(); }}
          showToast={showToast}
        />
      )}
    </div>
  );
}
